// extracted by mini-css-extract-plugin
module.exports = {"desc":"icon_desc__3qb7Y","Active":"icon_Active__3uT5-","svg_icon":"icon_svg_icon__1iaXE","svg_iconAsc":"icon_svg_iconAsc__1-Kx0","refresh__icon":"icon_refresh__icon__1RDUq"};